import React, { useEffect, useState } from "react";

import Menu from "../S1_Header/menu";
import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import {
  A,
  Bg,
  Hello,
  P,
  Position,
  SectionHeading,
  SectionSubHeading,
  SectionWrapper,
  Spanfollow,
} from "../../../styles";
import SlideBar from "../../../Componenets/SlideBar";

// import Loading from "./loading";

const Background = styled.div`
  min-height: 100vh;
  background-image: url("/images/bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  place-content: center;
  padding: 0 0 0 40px;

  @media screen and (max-width: 600px) {
    padding: 0;
  }
`;

const CustomGridMain = styled(Grid)`
  align-items: center;
`;
const ImageGrid = styled(Grid)`
  text-align-last: center;
`;

const CustomGrid = styled(Grid)`
  max-width: 80%;
  @media screen and (max-width: 1140px) {
    max-width: 58%;
  }
  @media screen and (max-width: 700px) {
    max-width: 100%;
  }
`;
const Heading = styled.h5`
  font-weight: 600;
  margin-top: 5px;
  margin-bottom: ${(props) => (props.mb ? props.mb : "5px")};
  font-size: 20px;
  color: #ffffff;
`;
const Text = styled.span`
  font-size: ${(props) => (props.fs ? props.fs : "20px")};
  color: #fff;
  font-weight: 200;
  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
  @media screen and (max-width: 330px) {
    /* font-size: 12px; */
  }
`;
const Div = styled.div`
  /* display: flex;
  justify-content: center; */
`;
const Box = styled.div`
  text-align: ${(props) => (props.align ? props.align : "")};
  background: ${(props) => (props.bg ? props.bg : "unset")};
  backdrop-filter: blur(9.5px);
  -webkit-backdrop-filter: blur(9.5px);
  border: ${(props) => (props.border ? props.border : "2px solid #ffffff")};
  padding: ${(props) => (props.padding ? props.padding : "10px 0")};
  /* max-width: ${(props) => (props.maxWidth ? props.maxWidth : "50%")}; */
  padding-left: ${(props) => (props.pl ? props.pl : "")};
  margin-top: ${(props) => (props.mt ? props.mt : "0px")};
  @media screen and (max-width: 1240px) {
    min-height: ${(props) => (props.minh ? props.minh : "")};
  }
  @media screen and (max-width: 899px) {
    padding-left: ${(props) => (props.pl899px ? props.pl899px : "10px")};
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.padding599 ? props.padding599 : "")};
    max-width: 100%;
    /* min-height: ${(props) => (props.mh ? props.mh : "")}; */
  }
  @media screen and (max-width: 387px) {
    min-height: ${(props) => (props.mh ? props.mh : "")};
  }
`;
const AnchorLinki = styled.a`
  text-decoration: none;
`;
const TokeImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 400px
`

const Index = () => {
  return (
    <div>
      <SlideBar/>
      <Menu />
      <Background>
        <SectionWrapper>
          <Container maxWidth="xl">
            <CustomGridMain container>
              <Grid xs={12} md={6}>
                <SectionHeading p="0px 0 40px 0">Tokenomics</SectionHeading>
                <Div>
                  <CustomGrid container spacing={1.3}>
                    <Grid item xs={12}>
                      <Box mh="70px" align="center" padding="10px">
                        <Heading fs="20px">
                          Ticker: <Text fs="20px">HOLT</Text>
                        </Heading>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box mh="10px" align="center" padding="10px">
                        <Heading fs="20px">
                          Total Supply: <Text fs="20px">100 Billion</Text>
                        </Heading>
                      </Box>
                    </Grid>

                    <Grid item xs={6}>
                      <Box mh="85px" mt="0px" align="center">
                        <Heading fs="20px">
                          Buy:
                          <Text fs="20px"> 5% </Text>
                        </Heading>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box mh="85px" mt="0px" align="center">
                        <Heading fs="20px">
                          Sell:
                          <Text fs="20px"> 10%</Text>
                        </Heading>
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Box
                        border="none"
                        bg="rgba(70, 214, 185, 0.8)"
                        mt="0px"
                        align="center"
                        padding="12px 0"
                      >
                        <Heading fs="20px">
                          Contract:
                          <Text fs="20px">
                            {" "}
                            <AnchorLinki href="https://etherscan.io/address/0x7D4979302Eada5eb7888Ba4CFc3Fa712Cb4Ad110">
                              0x7D...110
                            </AnchorLinki>{" "}
                          </Text>
                        </Heading>
                      </Box>
                    </Grid>
                  </CustomGrid>
                </Div>
              </Grid>
              <ImageGrid xs={12} md={6}>
                <TokeImage
                  src="/images/tokenomicsimg.png"
                />
              </ImageGrid>
            </CustomGridMain>
          </Container>
        </SectionWrapper>
      </Background>
      {/* <Contract>Contract Address: TBA</Contract> */}
    </div>
  );
};

export default Index;
